<script>
    import {PATH_PREFIX} from '../apiUrls.js';
  import { debounced, get } from '../utils.js';
  import { validateInput } from './Form/utils.js';
  import { createEventDispatcher } from 'svelte';
  import {sgettext} from '../i18n.js';

  export let value = '';
  export let id = '';
  export let label = '';
  export let placeholder = '';
  export let apiurl = '';
  export let required = false;
  export let message = sgettext('$$POSSIBLE_DUPLICATE_FOUND$$');
  export let isValid = true;
  export let errors = '';
  export let schema = {};
  export let multiline = false;
  export let redirectUrl = '';
  export let multiplyPercentage = true;

  let duplicates = [];
  let touched = false;

  $: if(!value) {
    duplicates = [];
  }

  const dispatch = createEventDispatcher();

  async function checkDuplicate(event) {
    if (value.length > 3 && apiurl) {
      try {
        const resp = await get(`${apiurl}?name=${value}`);
        const json = await resp.json();

        if(!resp.ok) {
          errors = `${sgettext('$$UNABLE_CHECK_DUPLICATE$$')}${json.detail}"`;
          isValid = false;
        } else {
          isValid = true;
          duplicates = json;

          const identical = duplicates.filter(d => d.similarity === 100);

          dispatch('check', identical);
        }
      } catch (err) {
        console.error(err)
      }
    } else if (value.length === 0) {
      duplicates = [];
    }
  }

  const handleKeyUp = debounced(1500, checkDuplicate);

  function getBackgroundColor(similarity) {
    let color = '#c3e6cb';

    if (similarity === 100) {
      color = '#f5c6cb';
    } else {
      color = '#ffeeba';
    }

    return color;
  }



  async function handleOnBlur(event){
    try {
      await validateInput(schema, id, value);
      isValid = true;
    } catch(err) {
      isValid = false;
      errors = err.message;
    }

  }
</script>

{#if label}
  <label for={id} title={required ? sgettext('$$FIELD_REQUIRED$$') : ''}
    >{label}</label
  >
{/if}

{#if !multiline}
  <input
    type="text"
    autocomplete="off"
    {id}
    class:invalid={!isValid}
    {placeholder}
    {required}
    class="form-control"
    bind:value
    on:keyup={handleKeyUp}
    on:focus={() => (touched = true)}
    on:blur={handleOnBlur}
    on:change={handleKeyUp}
  />
{:else}
  <textarea
    {id}
    {placeholder}
    class:invalid={!isValid}
    class="form-control"
    bind:value
    on:keyup={handleKeyUp}
    on:focus={() => (touched = true)}
    on:blur={handleOnBlur}
  />
{/if}

{#if duplicates.length && value}
  <div class="possible-duplicate">
    <label>{message}</label>
    <ul>
      {#each duplicates as d}
        <li style={`background-color: ${getBackgroundColor(d.similarity)}`}>
          {#if redirectUrl != ''}
            <a
              href={`${PATH_PREFIX}/sw/elements_database/${d.id}/?status=CURRENT&amp;back=/sw/elements_database/v1/create/?name=${d.text}`}
              title={`${d.similarity * 100}% similar`}
              target="_blank"
              rel="noopener noreferrer"
              class="matching-text">{d.text}</a
            >
          {:else if multiplyPercentage === 'true'}
            <span title={`${d.similarity * 100}% similar`} class="matching-text"
              >{d.text}</span
            >
          {:else}
            <span title={`${d.similarity}% similar`} class="matching-text"
              >{d.text}</span
            >
          {/if}
        </li>
      {/each}
    </ul>
  </div>
{/if}

{#if !isValid}
  <div class="errors">{errors}</div>
{/if}

<style>
  .possible-duplicate {
    padding: 5px 0;
    border: 1px solid #dddddd;
    border-top: none;
  }

  .possible-duplicate label {
    margin-left: 15px;
    font-weight: bold;
  }

  .possible-duplicate ul {
    padding: 0 5px;
    margin: 0;
    list-style: none;
  }

  .possible-duplicate li {
    padding: 3px 15px;
  }

  .indicator {
    height: 3px;
  }

  .errors {
    color: #dc3545;
    font-size: 13px;
  }

  .invalid {
    border: 1px solid #dc3545;
  }
</style>
